import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const Warning = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 9.6A.7.7 0 1 0 8 12a.7.7 0 0 0 0-1.4zM8 4a.6.6 0 0 0-.6.6V9a.6.6 0 1 0 1.2 0V4.6A.6.6 0 0 0 8 4z"/>
      </svg>)} {...props}/>));
export default Warning;
